export default __webpack_public_path__ + "static/media/right-triangle.e7b7f9a8.svg";